import {Pageable, Diagnosis, Response} from "@core/model";
import {ApiBuilder} from "..";

type DiagnosisParams = {
  assetId?: string;
  from?: number;
  to?: number;
  page?: number;
  size?: number;
};

// Diagnosi per asset specifico o tutti gli assets con range temporale
const fetchDiagnosis = (builder: ApiBuilder) =>
  builder.query<Pageable<Diagnosis>, DiagnosisParams>({
    query: params => {
      const queryParams = new URLSearchParams();
      if (params.assetId) {
        queryParams.append("assetId", params.assetId.toString());
      }
      if (params.from) {
        queryParams.append("from", params.from.toString());
      }
      if (params.to) {
        queryParams.append("to", params.to.toString());
      }
      if (params.page !== undefined) {
        queryParams.append("page", params.page.toString());
      }
      if (params.size !== undefined) {
        queryParams.append("size", params.size.toString());
      }

      return {
        url: `/api/diagnosis/range${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
        method: "GET",
      };
    },
    transformResponse: (response: Response<Pageable<Diagnosis>>) => {
      return response.data;
    },
    providesTags: result =>
      result?.content
        ? [
            ...result.content.map((p: Diagnosis) => ({
              type: "diagnosis" as const,
              id: p.assetId,
            })),
            {type: "diagnosis", id: "LIST"},
          ]
        : [{type: "diagnosis", id: "LIST"}],
  });

// Diagnosi più recente per asset specifico o tutti gli assets
const fetchDiagnosisLatest = (builder: ApiBuilder) =>
  builder.query<Diagnosis[], {assetId?: number}>({
    query: params => {
      const queryParams = new URLSearchParams();
      if (params.assetId) {
        queryParams.append("assetId", params.assetId.toString());
      }

      return {
        url: `/api/diagnosis/latest${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
        method: "GET",
      };
    },
    transformResponse: (response: Response<Diagnosis[]>) => {
      return response.data;
    },
    providesTags: result =>
      result
        ? [
            ...result.map(p => ({type: "diagnosis" as const, id: p.assetId})),
            {type: "diagnosis", id: "LATEST"},
          ]
        : [{type: "diagnosis", id: "LATEST"}],
  });

export {fetchDiagnosis, fetchDiagnosisLatest};
